import { LessonSchema } from "@equipped/core/core/manifest";
import { ParseResult, err, ok } from "@equipped/core/core/result";
import { lessonFields } from "../lessonFields";
import { renderFields } from "../fieldTypes";
import { DocumentPanel } from "./DocumentPanel";

const FIELDS = renderFields(lessonFields);

/** `LessonSchema.safeParse` adapted to the shared `ParseResult` shape `DocumentPanel`
 *  expects — a per-lesson validation, distinct from `parseManifest`'s whole-pack
 *  check (which also enforces cross-lesson invariants like unique ids — those
 *  still only surface on the PACK panel's own Save, by design: a lesson in
 *  isolation can't know its siblings). */
function validateLesson(input: unknown): ParseResult<unknown> {
  const result = LessonSchema.safeParse(input);
  if (result.success) return ok(result.data);
  return err(result.error.issues.map((issue) => (issue.path.length ? `${issue.path.join(".")}: ${issue.message}` : issue.message)));
}

export function LessonPanel({
  value,
  onChange,
  onSave,
  onDiscard,
  dirty,
  saving,
  saveError,
  onBrowseFile,
}: {
  value: Record<string, unknown>;
  onChange: (next: Record<string, unknown>) => void;
  onSave: () => void;
  onDiscard: () => void;
  dirty: boolean;
  saving: boolean;
  saveError: string | null;
  onBrowseFile?: (fieldKey: string) => void;
}) {
  return (
    <DocumentPanel
      title={(value.title as string) || "New lesson"}
      fields={FIELDS}
      value={value}
      onChange={onChange}
      onSave={onSave}
      onDiscard={onDiscard}
      dirty={dirty}
      saving={saving}
      saveError={saveError}
      validate={validateLesson}
      onBrowseFile={onBrowseFile}
    />
  );
}
